import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import RkAccountMenu from "../../components/RkAccountMenu/RkAccountMenu";
import styles from "./RkHome.module.scss";

const MARK_RETURN_IMAGE = "/images/external/rk/mark_return.png";
const VIEW_RETURN_IMAGE = "/images/external/rk/view_return.png";

const TASKS = [
  {
    id: "mark_return",
    title: "Mark\nreturn",
    image: MARK_RETURN_IMAGE,
    path: "/rk/mark-return",
  },
  {
    id: "view_return",
    title: "View\nreturn",
    image: VIEW_RETURN_IMAGE,
    path: "/rk/view-return",
  },
];

const RkHome = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <RkAccountMenu buttonClassName={styles.menuButton} />
      </div>

      <div className={styles.content}>
        <h1 className={styles.pageTitle}>Select task type</h1>

        {TASKS.map((task) => (
          <button
            key={task.id}
            type="button"
            className={styles.card}
            onClick={() => navigate(task.path)}
          >
            <img
              src={task.image}
              alt=""
              className={styles.cardImage}
              aria-hidden="true"
            />
            <span className={styles.cardTitle}>{task.title}</span>
            <span className={styles.cardArrow}>
              <ArrowRight size={32} />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RkHome;
